<template>
<div>
	<!-- <h1>NodesContainer</h1> -->
	<router-view />
</div>
</template>

<script>
export default {
	name: "nodes-view",
};
</script>


// WEBPACK FOOTER //
// src/components/containers/NodesContainer.vue